import React, {Component} from 'react';
 import {DropdownButton,  MenuItem} from 'react-bootstrap';
import {BootstrapTable, TableHeaderColumn} from 'react-bootstrap-table';
  import config from  '../../../config';
import {prepareSelectOptionsList,actionsFormatter,dateFormatter, customFormatter,  getFieldByPathFormatter} from 'util/Utils';
import moment from 'moment'

import {UPDATE_ADMIN_PRODUCT, DELETE_ADMIN_PRODUCT,ADD_SELECTED_PRODUCTS,
     } from "actions/actionTypes";

class AdminSubscriptionListTable extends Component {
    static get contextTypes() {
        return {
            router: React.PropTypes.object.isRequired,
        };
    }

    constructor(props) {
        super(props);
        this.state = {
            perPage: config.table.numberPerPage,
        };
        this.tableRef = null
    }
    customActionsFormatter(cell, row, extra){
        var menuItemsMap  =    [ {onClick: 'editRecord', label: 'Edit'}  ]
        if (!row.Deleted){
            menuItemsMap.push({onClick: 'showRemoveDialog', label: 'Delete'})
        }
        return  actionsFormatter.call(this, cell, row, {menuItemsMap})
    }
    editRecord(row){
        this.props.editRecord(row);
    }

    showRemoveDialog(row) {
        this.props.showRemoveDialog(row)
    }

    formatType(cell, row, extra){
       var foundType =  _.find(config.subscriptionTypes, function (value, key) {
             return key == row.Type
        })
         return foundType ? foundType.label  : ''
    }
     formatDeleted(cell, row, extra){
        return row.Deleted ? 'Deleted' : ''
    }
    formatProductName(cell, row, extra){
         if(_.get(row.Product, ['ProductName'], '')) {
             return <div>
                 <div>{_.get(row.Product, ['ProductName'], '')}</div>
                 <div style={{
                     marginTop: 5,
                     color: 'orange'
                 }}>{ _.get(row.Product, ['ShopifyProductID'], '')}</div>
             </div>
         } else{
             return ''
         }
    }
    formatDesirablePrice(cell, row, extra){
        if(row.Type== 'PriceDrop' && _.get(row, ['DesirablePrice'], '')) {
            return <div>{_.get(row, ['DesirablePrice'], '')}</div>
        } else{
            return ''
        }
    }
    formatEmailsSent(cell, row, extra){
        return  <div  >{_.map(row.EmailsSent ? row.EmailsSent : [], function (emailSent, index) {

            return (<div style={{color:   'green'}} key={index} className="bot8">
                            <span  >{moment(emailSent.createdAt).format("YYYY MM DD")} </span>
                            <span>  {moment(emailSent.createdAt).format("HH:mm")}</span>
                            <div style={{  color: 'orange'}} >  {  emailSent.ShopifyProductID} </div>
                        </div>)
        })}</div>
    }


    render() {
         return (
            <div className="  list-group">
                <BootstrapTable data={this.props.adminSubscriptions.data}
                                 remote={ true }
                                ref={(ref) => {
                                    if (!this.tableRef && ref) {
                                        this.tableRef = ref;

                                    }
                                }}
                                hover={true}
                                condensed={true}
                                striped={true}
                                selectRow={{
                                    mode: 'checkbox',
                                    columnWidth: '29px',
                                    onSelect: this.props.onRowSelect,
                                    onSelectAll: this.props.onAllRowSelect,
                                    customComponent: this.props.customMultiSelect
                                }}
                                options={ {
                                    ...config.bootstrapTableOptions,
                                    onSortChange: this.props.onSortChange
                                 } }

                >

                    <TableHeaderColumn width="60px" columnClassName={'break-word'} dataField='Email' dataAlign="center" dataSort={true}>Email</TableHeaderColumn>
                    <TableHeaderColumn width="50px"dataFormat={this.formatType.bind(this)}  dataField='Type' dataAlign="center"dataSort={true}>Type</TableHeaderColumn>
                    <TableHeaderColumn  dataField="_id" isKey={true} hidden={true} autoValue={ true }
                                       hiddenOnInsert>Id</TableHeaderColumn>
                    <TableHeaderColumn width="80px" dataFormat={this.formatProductName.bind(this)}     dataField='Product.ProductName' dataAlign="center"dataSort={true}>Product Name</TableHeaderColumn>

                    <TableHeaderColumn width="50px" dataField='GBGProduct.Brand'  formatExtraData={ {path:['GBGProduct',  'Brand']}}
                                       dataFormat={ getFieldByPathFormatter }  dataAlign="center"dataSort={true}>Brand</TableHeaderColumn>
                    <TableHeaderColumn width="80px" formatExtraData={ {path:['GBGProduct',  'Model']}}
                                       dataFormat={ getFieldByPathFormatter }  dataField='GBGProduct.Model' dataAlign="center"dataSort={true}>Model</TableHeaderColumn>

                    <TableHeaderColumn width="65px"   dataFormat={this.formatDesirablePrice.bind(this)}  dataField='DesirablePrice' dataAlign="center" dataSort={true} >Desirable Price</TableHeaderColumn>
                    <TableHeaderColumn width="60px" dataField='TextToMatch' dataAlign="center" dataSort={true}>Search text</TableHeaderColumn>

                    <TableHeaderColumn width="65px"  columnClassName={'break-word'} dataFormat={this.formatEmailsSent.bind(this)}   dataAlign="center" >Sent</TableHeaderColumn>
                    <TableHeaderColumn width="50px"  dataField="createdAt" dataAlign="center" dataFormat={ dateFormatter }
                                       formatExtraData={ {'name': 'createdAt', 'format': 'MM-DD YYYY'} }
                                       dataSort={true}>Created</TableHeaderColumn>
                    {/*<TableHeaderColumn width="50px" dataField='Deleted' dataFormat={this.formatDeleted.bind(this)}  dataAlign="center"dataSort={true}>Deleted</TableHeaderColumn>*/}
                    <TableHeaderColumn width="65px"    dataFormat={ customFormatter }
                                       formatExtraData={ {
                                           path: ['SubscriptionCustomData', 'ZipCode'],
                                           format: (value) => {
                                               if (value) {
                                                   return 'Zip code: ' + value
                                               }
                                           }
                                       }}
                                       dataAlign="center" >Data</TableHeaderColumn>

                    <TableHeaderColumn width="20px" dataAlign="center"  columnClassName={'actions-column'}
                                       dataFormat={ this.customActionsFormatter.bind(this) }  >Actions</TableHeaderColumn>
                </BootstrapTable>

            </div>
        );
    }
}


export default AdminSubscriptionListTable;
